/* eslint-disable @typescript-eslint/camelcase */
import { API_USER } from '../helpers/api';
import { logger, loggerError } from '../helpers/Log';
export function updateProfileLanguage(_a) {
    var application = _a.application, language = _a.language, _b = _a.timezone, timezone = _b === void 0 ? 'Etc/UTC' : _b, access_token = _a.access_token, userId = _a.userId;
    logger('change profile language: ', application, language);
    try {
        return fetch("".concat(API_USER(userId)), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer ".concat(access_token),
            },
            body: JSON.stringify({
                user: { profile_attributes: { language: language, timezone: timezone } },
            }),
        });
    }
    catch (error) {
        loggerError('fail get change profile language');
        return loggerError(error);
    }
}
//# sourceMappingURL=updateProfileLanguage.js.map